import api from './api';

const API_URL = '/mission-templates';

export const getTemplates = async () => {
  try {
    const response = await api.get(API_URL);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch mission templates');
  }
};

export const getTemplate = async (id) => {
  try {
    const response = await api.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch mission template');
  }
};

export const createTemplate = async (templateData) => {
  try {
    const response = await api.post(API_URL, templateData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to create mission template');
  }
};

export const updateTemplate = async (id, templateData) => {
  try {
    const response = await api.put(`${API_URL}/${id}`, templateData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to update mission template');
  }
};

export const deleteTemplate = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to delete mission template');
  }
};

export const generateMissionFromTemplate = async (id) => {
  try {
    const response = await api.post(`${API_URL}/${id}/generate`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to generate mission from template');
  }
};
